import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { ApplicationComponent } from '../../shared/base';
import { MatSelectModule } from '@angular/material/select';
import { FormBuilder, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ResponsiveService } from '../../shared/services';
import { LoginComponent } from '../../website/login/login.component';

@Component({
    selector: 'app-nav-bar',
    standalone: true,
    imports: [
        RouterModule,
        CommonModule,
        MatDialogModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        TranslateModule,
        MatSelectModule,
        ReactiveFormsModule,
        FormsModule,
    ],
    templateUrl: './nav-bar.component.html',
    styleUrl: './nav-bar.component.sass',
})
export class NavBarComponent extends ApplicationComponent {
    private fb = inject(FormBuilder);
    protected responsive = inject(ResponsiveService);

    loginForm: FormGroup = new FormGroup({
        email: this.fb.control('', []),
        password: this.fb.control('', []),
    });

    loginDialog() {
        this.openDialog({
            hideFooter: true,
            component: LoginComponent,
            title: 'Login',
            size: 'small',
        });
    }
}
